/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.controllers {

    export interface IProcessEventConfigurationScope extends angular.IScope {
        model: models.ProcessEventConfigurationModel;
    }

    export class ProcessEventConfigurationController implements IController {
        scope: IProcessEventConfigurationScope;

        constructor(
            $scope: IProcessEventConfigurationScope,
            $routeParams: angular.route.IRouteParamsService,
            processEventConfigurationService: services.ProcessEventConfigurationService,
            securityMatrixService: services.SecurityMatrixService,
            systemLevelService: services.SystemLevelService,
            processActionService: services.ProcessActionService,
            deleteService: services.DeleteService) {
            this.scope = $scope;

            var processConfigId = $routeParams["id"];

            this.scope.model = new models.ProcessEventConfigurationModel(
                processConfigId,
                processEventConfigurationService,
                securityMatrixService,
                systemLevelService,
                processActionService,
                deleteService);
        }
    }
}

warsApp.registerController("ProcessEventConfigurationController", ["$scope", "$routeParams", "processEventConfigurationService", "securityMatrixService", "systemLevelService", "processActionService", "deleteService"]);